<section class="partners" id="partners">
  <div class="partners-bg"></div>
  <div class="partners-content">
    <h2>Become a restaurant or local shop partner</h2>
    <p>
      Take your business to new heights by partnering with OrderYaa, the leading delivery service trusted
      by businesses large and small.
      <br />
      We dare to always go further, helping you reach untapped customer bases, boost order volume, and
      drive more sales.
    </p>
    <a class="partners-cta" [href]="partnerUrl" target="_blank" rel="noopener">
      Become a Partner
    </a>
  </div>
  <img class="partners-decor" src="/images/flower.png" alt="" />
</section>
